import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";

export default function HoldingStateModal(props) {
  const { onClickYes, onClickNo } = props;

  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  return (
    <TopLevelWrapper>
      <Modal>
        <Text>회원권이 홀딩상태입니다.</Text>
        <Text>홀딩을 해제하시겠습니까?</Text>
        <ButtonWrapper>
          <Button color='#FF8B48' onClick={onClickYes}>
            <WhiteText>예</WhiteText>
          </Button>
          <Button color='#6DD49E' onClick={onClickNo}>
            <WhiteText>아니요</WhiteText>
          </Button>
        </ButtonWrapper>
      </Modal>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 30vh;
  min-width: 280px;
  max-width: 400px;

  // height: 30vh;
  height: 18vh;
  min-height: 200px;
  max-height: 300px;

  overflow: hidden;

  border-radius: 30px;
  background-color: #FFFFFF;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 36px;

  width: 80%;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45%;
  height: 60px;

  border-radius: 12px;
  background-color: ${props => props.color};
`;

const WhiteText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 10px;
  }
  @media (min-height: 640px) {
    font-size: 12px;
  }
  @media (min-height: 720px) {
    font-size: 14px;
  }
  @media (min-height: 760px) {
    font-size: 16px;
  }
  @media (min-height: 800px) {
    font-size: 18px;
  }
  @media (min-height: 1000px) {
    font-size: 20px;
  }
  @media (min-height: 1200px) {
    font-size: 21px;
  }

  :hover {
    cursor: default;
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 10px;

  color: #000000;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 10px;
  }
  @media (min-height: 640px) {
    font-size: 12px;
  }
  @media (min-height: 720px) {
    font-size: 14px;
  }
  @media (min-height: 760px) {
    font-size: 16px;
  }
  @media (min-height: 800px) {
    font-size: 18px;
  }
  @media (min-height: 1000px) {
    font-size: 20px;
  }
  @media (min-height: 1200px) {
    font-size: 21px;
  }

  :hover {
    cursor: default;
  }
`;